export const adjustForOvernightShift = (shiftStartTime, dateTimeToAdjust) => 
    dateTimeToAdjust.isBefore(shiftStartTime) && dateTimeToAdjust.add(1, 'days');

export const overlaps = (startA, endA, startB, endB) => 
    (startA.isBefore(endB) && endA.isAfter(startB)) || (startA.isSame(startB) && endA.isSame(endB));

export const isTransfer = (segment) => segment.segmentType.id === 3;

export const isBreak = (segment) => segment.segmentType.id === 4;